// extracted by mini-css-extract-plugin
export default {"verticalDivider":"jAKrm"};